// @flow
import {ActionsObservable, ofType} from 'redux-observable';
import {forkJoin} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {
  ActionCreator,
  buildCatchError,
  createReducer,
} from '../../../store/utils';
import {saveSocialMediasApi} from './api';

import type {Action} from '../../../store/utils';
import type {SaveSocialMediaRequest} from './api';

export type SocialMediasAction = Action & {
  error?: string,
  socialMediasData?: SaveSocialMediaRequest[],
};

export type SocialMediasConfigState = {
  isSaving?: boolean,
  error?: string,
  savingSuccess?: boolean,
};

export class SaveSocialMedias extends ActionCreator<SocialMediasAction> {}
export class SaveSocialMediasSuccess extends ActionCreator<SocialMediasAction> {}
export class SaveSocialMediasErrorFn extends ActionCreator<SocialMediasAction> {}

export class SocialMediasResetState extends ActionCreator<SocialMediasAction> {}

export const actions = {
  saveSocialMedias: (payload: SocialMediasAction) =>
    new SaveSocialMedias(payload),
  resetState: () => new SocialMediasResetState(),
};

export const initialState = {};

export default createReducer<SocialMediasConfigState>(initialState, {
  [SaveSocialMedias.type]: _ => ({isSaving: true}),
  [SaveSocialMediasSuccess.type]: () => ({savingSuccess: true}),
  [SaveSocialMediasErrorFn.type]: (_, action: SocialMediasAction) => ({
    error: action.error,
  }),
  [SocialMediasResetState.type]: _ => initialState,
});

export function saveSocialMediasEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(SaveSocialMedias.type),
    switchMap(({socialMediasData}: SocialMediasAction) => {
      const tasks = [];
      socialMediasData.forEach((smd: SaveSocialMediaRequest) => {
        const obs = saveSocialMediasApi({
          identifier: smd.identifier,
          socialMediaTypeId: smd.socialMediaTypeId,
        }).pipe(
          map(_ => null),
          buildCatchError(
            SaveSocialMediasErrorFn,
            'Error al editar redes sociales'
          )
        );
        tasks.push(obs);
      });
      return forkJoin(tasks).pipe(
        map((dataError: SaveSocialMediasErrorFn[]) => {
          const e = dataError.find(x => !!x);
          if (e) return e;
          else return new SaveSocialMediasSuccess();
        })
      );
    })
  );
}
